Villa =  {

  init : ->
    console.log 'Villa init'
    $('.top-bar').css('position', 'relative');

  destroy : ->
    console.log "Intro destroy"





}